import { getPrivateApi } from "../lib/axiosConfig";
import {
  EditVehicle,
  NewVehicle,
  Vehicle,
  VehiclePlateData,
} from "../types/vehicles.types";
import { AppError } from "./classes";

const api = getPrivateApi();
const endpoint = "/vehicle";

export const getBalanceRequests = async () => {
  try {
    const data = await api.get(`${endpoint}/balance/APIPlacas`);
    return data;
  } catch (error: any) {
    const errMsg = "Erro ao buscar balanço de chamadas de veículos";
    console.error(errMsg, error?.response ?? error);
    const message = error?.response?.data?.message ?? errMsg;
    throw new AppError(message, error.status);
  }
};

export const getVehicles = async (): Promise<Vehicle[]> => {
  try {
    const { data } = await api.get(`${endpoint}/exists/client`);
    return data;
  } catch (error: any) {
    const message =
      error?.response?.data?.message ?? "Erro ao buscar veículos.";
    throw new AppError(message, error?.response?.status ?? error.status);
  }
};

export const getVehiclesByClient = async (
  clientId: string,
): Promise<Vehicle[]> => {
  try {
    const { data } = await api.get(`${endpoint}/client/${clientId}`);
    return data;
  } catch (error: any) {
    const message =
      error?.response?.data?.message ?? "Erro ao buscar veículos do cliente.";
    throw new AppError(message, error?.response?.status ?? error.status);
  }
};

export const getVehiclesByFleet = async (
  fleetId: string,
): Promise<Vehicle[]> => {
  try {
    const { data } = await api.get(`${endpoint}/fleet/${fleetId}`);
    return data;
  } catch (error: any) {
    const message =
      error?.response?.data?.message ?? "Erro ao buscar veículos da frota.";
    throw new AppError(message, error?.response?.status ?? error.status);
  }
};

export const getVehiclePlateData = async (
  licencePlate: string,
): Promise<Vehicle & { user?: any }> => {
  try {
    const { data } = await api.get(
      `${endpoint}/APIPlacas/${licencePlate}?isFleet=true`,
    );
    return data;
  } catch (error: any) {
    const message =
      error?.response?.data?.message ?? "Erro ao consultar placa.";
    throw new AppError(message, error?.response?.status ?? error.status);
  }
};

export const addVehicle = async (vehicle: NewVehicle): Promise<Vehicle> => {
  try {
    const { data } = await api.post(`${endpoint}`, vehicle);
    return data;
  } catch (error: any) {
    const message =
      error?.response?.data?.message ?? "Erro ao cadastrar veículo.";
    throw new AppError(message, error?.response?.status ?? error.status);
  }
};

export const editVehicle = async (vehicle: EditVehicle): Promise<Vehicle> => {
  const { id, ...body } = vehicle;
  try {
    const { data } = await api.put(`${endpoint}/${id}`, body);
    return data;
  } catch (error: any) {
    const message = error?.response?.data?.message ?? "Erro ao editar veículo.";
    throw new AppError(message, error?.response?.status ?? error.status);
  }
};

export const deleteVehicle = async (
  vehicleId: string,
  isFleet?: boolean,
): Promise<void> => {
  try {
    await api.delete(`${endpoint}/${vehicleId}${isFleet ? "?isFleet=true" : ""}`);
  } catch (error: any) {
    const message =
      error?.response?.data?.message ?? "Erro ao deletar veículo.";
    throw new AppError(message, error?.response?.status ?? error.status);
  }
};
